'use strict';

function SignupDialog() {
  this.id = null;
  this.node = null;

  this.el = {};
  this._classes = {
    jsCheckYourRateCta: 'js--check-your-rate-cta',
    signupDialog: 'signup-dialog',
    secondaryDialog: 'signup-dialog--secondary'
  };

  this.init = function () {
    if (location.pathname === '/signup' || location.pathname === '/signup-extended') {
      $(this.node).remove();
      this.node = null;
    } else {
      this.el.$signupDialog = $('.' + this._classes.signupDialog);
      this.el.$node = $(this.node);
    }
  };

  this.initAllReady = function () {
    if (this.node) {
      this.el.$node.on('click', this._showSignup.bind(this));
      this.el.$signupDialog.mogo().onClickClose = this._onClickCloseDialog.bind(this);
    }
  };

  this._showSignup = function (event) {
    var _this = this;

    // the secondary dialog has only copy changes
    if (this.el.$node.hasClass(this._classes.jsCheckYourRateCta)) {
      this.el.$signupDialog.addClass(this._classes.secondaryDialog);

      // HACK: setTimout is used to send this event after the google tag manager link click event.
      setTimeout(function () {
        _this._analyticsEventVariant();
      }, 50);
    } else {
      this.el.$signupDialog.removeClass(this._classes.secondaryDialog);

      // HACK: setTimout is used to send this event after the google tag manager link click event.
      setTimeout(function () {
        _this._analyticsEvent();
      }, 50);
    }

    event.preventDefault();
    if (!this.el.$signupDialog.length) {
      var $dialog = $("<div class='signup-dialog mogo-ui-dialog--dark mogo-ui-dialog--transparent darkLayout small-12'></div>");
      $dialog.mogo().create('Dialog', {
        url: '/signup-dialog',
        disableBackgroundScroll: true,
        fixFormsOnTouchDevices: true,
        onUrlLoaded: this._onDialogLoaded.bind(this, $dialog)
      });
    } else {
      this.el.$signupDialog.mogo().show();
      this._disclaimers();
    }
    this._hideNavigation();
  };

  this._hideNavigation = function () {
    var marketing_nav = $('.js--marketing-nav-toggle');
    if ($('body').find(marketing_nav).length > 0) {
      marketing_nav.mogo().toggleHamburger();
    }
  };

  this._onDialogLoaded = function ($dialog) {
    $dialog.mogo().show(); // show
    $dialog.find('[data-mogo-ui="SignUpComponent"]').mogo().parse(); // parse the contents of the dialog
    this._disclaimers();
  };

  this._analyticsEvent = function () {
    dataLayer.push({
      event: 'DLevent.Pageview',
      Page: '/signup-dialog'
    });
  };

  this._analyticsEventVariant = function () {
    dataLayer.push({
      event: 'DLevent.Pageview',
      Page: '/signup-dialog-checkrate'
    });
  };

  this._analyticsDialogClose = function () {
    var _pageUrl = window.location.pathname;

    dataLayer.push({
      event: 'DLevent.Pageview',
      Page: _pageUrl
    });
  };

  this._onClickCloseDialog = function () {
    this._analyticsDialogClose();
  };

  this._disclaimers = function () {
    var _pageUrl = window.location.pathname;
    if (!this.$globalLegal && _pageUrl !== '/') {
      this.$globalLegal = $('.js--marketing-disclaimers-modal');
      var apiPresenter = window.marketingApiPresenter = window.marketingApiPresenter || new APIPresenter();
      this.$globalLegal.mogo().create('LegalDisclaimer', {
        otherLegal: ['disclaimer.mogoCorporateStandard', 'disclaimer.appleTrademarkLogos', 'disclaimer.googlePlayTrademarkLogos', 'disclaimer.otherCompanyLogos'],
        itemContainer: '<ul class="marketing-footer-disclaimers__list"></ul>',
        itemClasses: 'marketing-footer-disclaimers__list-item',
        presenter: apiPresenter
      });
    }
  };
}